const API_ENDPOINT = "https://sell.sidekicks.co.uk/api";
// const API_ENDPOINT = "http://localhost:8000/api";

// Show notification function
function showNotification(message, type = 'info') {
    // Remove any existing notifications
    const existingNotification = document.querySelector('.notification');
    if (existingNotification) {
        existingNotification.remove();
    }
    
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    
    // Add styles
    notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 15px 20px;
        border-radius: 8px;
        color: white;
        font-weight: 500;
        z-index: 9999;
        max-width: 400px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
        transform: translateX(100%);
    `;
    
    // Set background color based on type
    switch (type) {
        case 'success':
            notification.style.backgroundColor = '#10b981';
            break;
        case 'error':
            notification.style.backgroundColor = '#ef4444';
            break;
        case 'warning':
            notification.style.backgroundColor = '#f59e0b';
            break;
        default:
            notification.style.backgroundColor = '#3b82f6';
    }
    
    // Add to page
    document.body.appendChild(notification);
    
    // Animate in
    setTimeout(() => {
        notification.style.transform = 'translateX(0)';
    }, 10);
    
    // Auto remove after 4 seconds
    setTimeout(() => {
        notification.style.transform = 'translateX(100%)';
        setTimeout(() => {
            if (notification.parentNode) {
                notification.remove();
            }
        }, 300);
    }, 4000);
}

// Email validation function
function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// Check points function
async function checkPoints() {
    const emailInput = document.getElementById('emailInput');
    const email = emailInput.value.trim();
    
    if (!email) {
        showNotification('Please enter your email address', 'error');
        return;
    }
    
    if (!validateEmail(email)) {
        showNotification('Please enter a valid email address', 'error');
        return;
    }
    
    // Check points via Smile.io API
    const revealOverlay = document.querySelector('.reveal-overlay');
    const blurredElements = document.querySelectorAll('.blurred');
    const enterEmailText = document.querySelector('.points-label')
    
    // Add loading state
    const checkButton = document.querySelector('.check-button');
    const originalText = checkButton.innerHTML;
    checkButton.innerHTML = '<span>Checking...</span>';
    checkButton.disabled = true;
    
    try {
        // Make API call to Smile.io
        const resp = await fetch(`${API_ENDPOINT}/users/smile/points-balance/?email=${encodeURIComponent(email)}`, {
            method: 'GET',
        });
        console.log('API response:', resp.status);
        if (resp.status === 200) {
            const data = await resp.json();
            
            // Remove blur and overlay on successful response
            blurredElements.forEach(element => {
                element.classList.remove('blurred');
            });
            
            if (revealOverlay) {
                revealOverlay.style.display = 'none';
            }
            
            // Reset button
            checkButton.innerHTML = originalText;
            checkButton.disabled = false;
            
            // Extract points balance from response
            const pointsBalance = data.points_balance || 0;

            // Update the .points-value element in the Check your Points section
            const pointsCard = document.querySelector('.points-display .points-card');
            if (pointsCard) {
                const pointsValueElement = pointsCard.querySelector('.points-value');
                if (pointsValueElement) {
                    pointsValueElement.textContent = `${pointsBalance} SK`;
                    pointsValueElement.classList.remove('blurred');
                }

                const pointsEuroElement = pointsCard.querySelector('.points-euro');
                if (pointsEuroElement) {
                    const euroValue = (pointsBalance * 0.02).toFixed(2); // Assuming 1 SK = €0.01
                    pointsEuroElement.textContent = `= €${euroValue}`;
                    pointsEuroElement.classList.remove('blurred');
                }
            }

            if (enterEmailText) {
              enterEmailText.innerText = 'Your have:'
            }
            
            // Show success message with points
            showNotification(`Points revealed! You have ${pointsBalance} points`, 'success');
            
            console.log('Customer data:', data);
            console.log('Points balance:', pointsBalance);
        } else {
            // Handle non-200 status codes
            checkButton.innerHTML = originalText;
            checkButton.disabled = false;
            showNotification(`Error: ${resp.status} - Failed to retrieve points`, 'error');
            console.error(`HTTP error! status: ${resp.status}`);
        }
    } catch (error) {
        console.error('Error fetching customer data:', error);
        
        // Reset button on error
        checkButton.innerHTML = originalText;
        checkButton.disabled = false;
        
        // Show error message
        showNotification('Failed to retrieve points. Please try again.', 'error');
    }
}

// Add enter key support for email input
document.addEventListener('DOMContentLoaded', function() {
    const emailInput = document.getElementById('emailInput');
    
    if (emailInput) {
        emailInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                checkPoints();
            }
        });
    }
    
    // Add hover effects for interactive elements
    const interactiveElements = document.querySelectorAll('.view-all-link, .check-button');
    
    interactiveElements.forEach(element => {
        element.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-1px)';
            this.style.transition = 'transform 0.2s ease';
        });
        
        element.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0)';
        });
    });
});

// Add intersection observer for animations
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
        }
    });
}, observerOptions);

// Observe elements for animation
document.addEventListener('DOMContentLoaded', function() {
    const animatedElements = document.querySelectorAll('.earn-card, .spend-card, .points-card');
    
    animatedElements.forEach(element => {
        element.style.opacity = '0';
        element.style.transform = 'translateY(20px)';
        element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(element);
    });
});